"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMedicalCrossOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.012 6.005h1.993c.278.029.494.108.648.238.155.13.27.33.347.6V10h3a1 1 0 01.722.303A.97.97 0 0118 11v2a.941.941 0 01-.278.694.954.954 0 01-.723.306h-3v3.005c.003.238-.087.463-.27.676A.915.915 0 0113 18h-2.001a.916.916 0 01-.715-.32c-.19-.212-.284-.44-.284-.682V14H7a.948.948 0 01-.719-.306.953.953 0 01-.28-.694v-2a.966.966 0 01.28-.697A.948.948 0 017 10h3V6.829c.056-.232.174-.427.352-.586a.957.957 0 01.66-.238z' }))); };
exports.default = SvgMedicalCrossOutline;
//# sourceMappingURL=MedicalCrossOutline.js.map